var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#FDA616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.70556 12.375C6.77137 12.5798 7.58587 13.4235 8.43356 13.4235C9.69019 13.4235 10.4242 12.6652 10.4242 11.5684C10.4242 10.5525 9.91575 9.972 8.631 9.40725C7.07794 8.77838 6.11775 7.85869 6.11775 6.32644C6.11775 4.63331 7.34625 3.375 9.19575 3.375C10.17 3.375 11.1572 3.98812 11.4846 4.39762L10.6987 5.21606C10.3882 5.02256 10.0153 4.536 9.15356 4.536C7.85475 4.536 7.36031 5.42306 7.36031 6.165C7.36031 7.18144 7.93969 7.6815 9.252 8.262C10.8619 8.97187 11.6809 9.85894 11.6809 11.4553C11.6809 13.1333 10.5874 14.625 8.34244 14.625C7.42444 14.625 6.444 14.0119 5.8545 13.2615L6.70556 12.375ZM7.75294 6.57956C7.55662 6.17062 7.68769 5.76169 7.68769 5.76169C12.6624 4.94325 11.7461 9.78356 11.7461 9.78356C11.3535 9.03431 10.9609 8.89762 10.9609 8.89762C11.0261 6.102 7.75294 6.57956 7.75294 6.57956ZM9.97875 11.0115C10.1756 11.4891 9.94837 11.9858 9.94837 11.9858C4.284 12.7159 5.814 7.53638 5.81231 7.53638C6.11269 8.33175 6.48619 8.51794 6.48619 8.51794C6.37931 11.7613 9.97875 11.0115 9.97875 11.0115Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32951"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlr);
export default __webpack_public_path__ + "static/media/slr.7b8e8beb6838b82105a763d87445d984.svg";
export { ForwardRef as ReactComponent };